import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL || "https://journe-api.onrender.com/api";

export const setupAxiosInterceptors = (setLoading: (arg0: boolean) => void) => {
  axios.interceptors.request.use(config => {
    setLoading(true);
    return config;
  }, error => {
    setLoading(false);
    return Promise.reject(error);
  });

  axios.interceptors.response.use(response => {
    setLoading(false);
    return response;
  }, error => {
    setLoading(false);
    return Promise.reject(error);
  });
};

export const api = {
    //Dashboard
    getDashboardLayout: (userId: string) => `${baseURL}/dashboard/${userId}`,
    saveDashboardLayout: (userId: string) => `${baseURL}/dashboard/${userId}`,
    updateTile: (tileId: string) => `${baseURL}/tiles/${tileId}`,

    //Pull by type
    getTop10: (type: string, userId: string) => `${baseURL}/${type}/top10/${userId}`,
    getAll: (type: string, userId: string) => `${baseURL}/${type}/${userId}`,
    getById: (type: string, id: string) => `${baseURL}/${type}/single/${id}`,

    //Registration
    registerAuthor: () => `${baseURL}/authors`,

    //Books
    saveBook: () => `${baseURL}/books`,
    updateBook: () => `${baseURL}/books/updateBook`,

    //Characters
    saveCharacter: (userId: string) => `${baseURL}/characters/${userId}`,
    updateCharacter: (characterId: string) => `${baseURL}/characters/updateCharacter/${characterId}`,

}